export const ROUTE_PATHS = {
  HOME: "/",
  BOOKS: "/stories",
  STORY: "/story/:id",
  LOGIN: "/login",
  ABOUT: "/about",
  ADMIN: "/admin",
  ADMIN_CARROUSEL: "/admin/manage-carrousell",
  ADMIN_STORIES_CREATE: "/admin/stories/create",
  ADMIN_BOOKS_EDIT: "/admin/books/edit/:id",
  CONTACT: "/contacts",
};
